export const moveZapsLink = {
    href: '/app/move-zaps/',
    icon: { selected: 'arrowBigRight', unselected: 'arrowBigRight' },
    text: 'Move Zaps',
};
export const settingsLink = {
    href: '/app/settings/profile',
    icon: { selected: 'navCog', unselected: 'navCog' },
    text: 'Settings',
};
export const logOutLink = {
    href: '/logout',
    icon: 'arrowExit',
    text: 'Log out',
    onClick: () => {
        try {
            sessionStorage.clear();
            for (let i = 0; i < localStorage.length; i++) {
                const key = localStorage.key(i);
                if (key === null || key === void 0 ? void 0 : key.startsWith('apollo-cache-persist')) {
                    localStorage.removeItem(key);
                    i--;
                }
            }
        }
        catch (e) {
            console.log('Error clearing session storage on log out', e);
        }
    },
};
export const AccountsMenuLinks = [
    settingsLink,
    logOutLink,
];
const BOTTOM_LINKS = [
    {
        text: 'Explore templates',
        icon: { selected: 'actionExplore', unselected: 'actionExplore' },
        href: '/templates',
    },
    {
        text: 'Explore use cases',
        icon: { selected: 'navBriefcase', unselected: 'navBriefcase' },
        href: '/use-cases',
    },
    {
        text: 'Join Zapier Early Access',
        icon: 'miscBoltAlt',
        href: '/early-access',
    },
];
export const FALLBACK_TOP_NAV_RESPONSE = {
    topBarMenu: [
        {
            variant: 'product-2',
            heroArea: {
                heading: 'Zapier Automation Platform',
                subheading: 'No-code automation across 7,000+ apps',
                submenu: [
                    {
                        href: null,
                        text: 'PRODUCTS',
                        submenu: [
                            {
                                text: 'Zaps',
                                href: '/workflows',
                                icon: 'miscBoltAltFill',
                                description: 'Do-it-yourself automation for workflows',
                                iconBackground: 'cream',
                                iconColor: 'brand',
                            },
                            {
                                text: 'Tables',
                                href: '/tables',
                                icon: 'navTables',
                                description: 'Databases designed for workflows',
                                iconBackground: 'cream',
                                iconColor: 'brand',
                            },
                            {
                                text: 'Interfaces',
                                href: '/interfaces',
                                icon: 'navInterfacesV2',
                                description: 'Custom pages to power your workflows',
                                iconBackground: 'cream',
                                iconColor: 'brand',
                            },
                        ],
                    },
                    {
                        href: null,
                        text: 'CAPABILITIES',
                        submenu: [
                            {
                                text: 'App integrations',
                                description: 'Explore 7,000+ app integrations',
                                href: '/apps',
                            },
                            {
                                text: 'AI automation',
                                description: 'Cutting-edge AI to upgrade your workflows',
                                href: '/ai',
                            },
                            {
                                text: 'Security',
                                description: 'Enterprise-grade security',
                                href: '/security-compliance',
                            },
                        ],
                    },
                ],
            },
            promoArea: {
                header: {
                    heading: "What's new",
                    href: undefined,
                    subheading: '',
                },
                submenu: [
                    {
                        text: 'Canvas',
                        href: '/canvas',
                        icon: 'navCanvas',
                        description: 'Plan and map your workflows with AI',
                        tag: 'Beta',
                    },
                    {
                        text: 'AI Chatbot',
                        href: '/ai/chatbot',
                        icon: 'navAIChatbot',
                        description: 'Answer customer questions with AI chatbots',
                        tag: 'Beta',
                    },
                    {
                        text: 'Central',
                        href: '/central',
                        icon: 'navCentral',
                        description: 'Create your own AI assistants for any task',
                        tag: 'Beta',
                        tagColor: '#c1b7ff',
                    },
                    {
                        text: 'Functions',
                        href: '/l/functions',
                        icon: 'navFunctions',
                        description: 'Code your workflows in a web IDE',
                        tag: 'Beta',
                        tagColor: '#ffbf6e',
                    },
                ],
            },
            text: 'Product',
            bottomLinks: BOTTOM_LINKS,
        },
        {
            text: 'Solutions',
            variant: 'variant-c',
            header: {
                heading: 'Solutions',
                subheading: 'How Zapier can help you automate your work across teams',
            },
            submenu: [
                {
                    text: 'By team',
                    href: null,
                    icon: { selected: 'personGroup', unselected: 'personGroup' },
                    submenu: [
                        {
                            text: 'RevOps',
                            href: '/solutions/revops',
                            icon: 'miscWalletFill',
                            iconBackground: 'blue100',
                            iconColor: 'night',
                            description: 'Drive revenue through automation',
                        },
                        {
                            text: 'Marketing',
                            href: '/solutions/marketing',
                            icon: 'miscColorFill',
                            iconBackground: 'blue100',
                            iconColor: 'night',
                            description: 'Multiply campaign effectiveness and ROI',
                        },
                        {
                            text: 'IT',
                            href: '/solutions/it',
                            icon: 'navCogFill',
                            iconBackground: 'blue100',
                            iconColor: 'night',
                            description: 'Better manage systems with automation',
                        },
                        {
                            text: 'Sales',
                            href: '/solutions/sales',
                            icon: 'miscGraph',
                            iconBackground: 'blue100',
                            iconColor: 'night',
                            description: 'Close more deals',
                        },
                        {
                            text: 'Customer Support',
                            href: '/solutions/customer-support',
                            icon: 'miscHeadsetFill',
                            iconBackground: 'blue100',
                            iconColor: 'night',
                            description: 'Elevate customer satisfaction',
                        },
                        {
                            text: 'Leaders',
                            href: '/solutions/leaders',
                            icon: 'personGroupFill',
                            iconBackground: 'blue100',
                            iconColor: 'night',
                            description: 'Streamline decision-making processes',
                        },
                    ],
                },
                {
                    text: 'By app',
                    href: null,
                    icon: { selected: 'miscList', unselected: 'miscList' },
                    submenu: [
                        {
                            text: 'Salesforce',
                            href: '/apps/salesforce/integrations ',
                            serviceIcon: {
                                name: 'salesforce',
                                src: 'https://zapier-images.imgix.net/storage/services/1a4435539b4764e6ded3d368cabab387.png?auto=format&ixlib=react-9.8.1&fit=crop&q=50&w=60&h=60&dpr=2',
                            },
                        },
                        {
                            text: 'HubSpot',
                            href: '/apps/hubspot/integrations',
                            serviceIcon: {
                                name: 'hubspot',
                                src: 'https://zapier-images.imgix.net/storage/developer/cde9764aa8d19fdd6d591455dbe5a78d.png?auto=format&ixlib=react-9.8.1&fit=crop&q=50&w=60&h=60&dpr=2',
                            },
                        },
                        {
                            text: 'Slack',
                            href: '/apps/slack/integrations',
                            serviceIcon: {
                                name: 'slack',
                                src: 'https://zapier-images.imgix.net/storage/services/6cf3f5a461feadfba7abc93c4c395b33_2.png?auto=format&ixlib=react-9.8.1&fit=crop&q=50&w=60&h=60&dpr=2',
                            },
                        },
                        {
                            text: 'OpenAI',
                            href: '/apps/openai/integrations',
                            serviceIcon: {
                                name: 'openai',
                                src: 'https://zapier-images.imgix.net/storage/developer_cli/a86f51fcd659c4b311c82ba31a176e4a.png?auto=format&ixlib=react-9.8.1&fit=crop&q=50&w=60&h=60&dpr=2',
                            },
                        },
                        {
                            text: 'Microsoft Dynamics CRM',
                            href: '/apps/microsoft-dynamics-crm/integrations',
                            serviceIcon: {
                                name: 'microsoft dynamics crm',
                                src: 'https://zapier-images.imgix.net/storage/developer_cli/47648cb213e43a4c2f57e9e0bdf9699f.png?auto=format&ixlib=react-9.8.1&fit=crop&q=50&w=60&h=60&dpr=2',
                            },
                        },
                        {
                            text: 'Microsoft Teams',
                            href: '/apps/microsoft-teams/integrations',
                            serviceIcon: {
                                name: 'microsoft teams',
                                src: 'https://zapier-images.imgix.net/storage/services/22d6681f64c79dd71a34066afe1c54e2.png?auto=format&ixlib=react-9.8.1&fit=crop&q=50&w=60&h=60&dpr=2',
                            },
                        },
                        {
                            text: 'Zendesk',
                            href: '/apps/zendesk/integrations',
                            serviceIcon: {
                                name: 'zendesk',
                                src: 'https://zapier-images.imgix.net/storage/services/45e89018e756b043d806701f17dc2632.png?auto=format&ixlib=react-9.8.1&fit=crop&q=50&w=60&h=60&dpr=2',
                            },
                        },
                        {
                            text: 'Jira Software Cloud',
                            href: '/apps/jira-software-cloud/integrations',
                            serviceIcon: {
                                name: 'jira software cloud',
                                src: 'https://zapier-images.imgix.net/storage/developer_cli/ea4a5ee38c7a088e243745dd0b851784.png?auto=format&ixlib=react-9.8.1&fit=crop&q=50&w=60&h=60&dpr=2',
                            },
                        },
                        {
                            text: 'Marketo',
                            href: '/apps/marketo/integrations',
                            serviceIcon: {
                                name: 'marketo',
                                src: 'https://res.cloudinary.com/zapier-media/image/upload/f_auto/q_auto/v1716489224/universal-layout/out-of-app-nav/solutions/app-icons/marketo_cvo9d6.png',
                            },
                        },
                        {
                            text: 'View all apps',
                            href: '/apps',
                            icon: 'navApps',
                        },
                    ],
                },
                {
                    text: 'By use case',
                    href: null,
                    icon: { selected: 'navBriefcase', unselected: 'navBriefcase' },
                    submenu: [
                        {
                            text: 'Lead management',
                            description: 'Automate your way to more conversions',
                            href: '/lead-management',
                        },
                        {
                            text: 'Sales pipeline',
                            description: 'Automate handoffs and streamline sales',
                            href: '/sales-pipeline-management',
                        },
                        {
                            text: 'Marketing campaigns',
                            description: "Boost your marketing campaign's impact",
                            href: '/marketing-campaigns',
                        },
                        {
                            text: 'Customer support',
                            description: 'Quickly route tickets and responses',
                            href: '/customer-support-management',
                        },
                        {
                            text: 'Data management',
                            description: 'Connect app data for more insights',
                            href: '/data-management',
                        },
                        {
                            text: 'Project management',
                            description: 'Deliver projects seamlessly',
                            href: '/project-management',
                        },
                        {
                            text: 'Tickets and incidents',
                            description: 'Resolve issues and incidents faster',
                            href: '/ticket-incident-management',
                        },
                    ],
                },
            ],
            bottomLinks: BOTTOM_LINKS,
            promoArea: [
                {
                    type: 'article-stub',
                    text: 'Automation for RevOps',
                    href: '/solutions/revops',
                    imageUrl: 'https://res.cloudinary.com/zapier-media/image/upload/v1716501734/Global_Nav_April_2024_aeaycw.png',
                    description: 'See how Zapier can take your RevOps and GTM engine to the next level',
                    altText: 'Graphic that shows automation icons connected to a central hub',
                },
                {
                    type: 'link-list',
                    text: 'Zapier for',
                    href: null,
                    links: [
                        {
                            text: 'Startups',
                            href: '/startups',
                        },
                        {
                            text: 'Small and medium businesses',
                            href: '/smb',
                        },
                        {
                            text: 'Enterprise',
                            href: '/enterprise',
                        },
                    ],
                },
            ],
        },
        {
            text: 'Resources',
            variant: 'variant-b',
            submenu: [
                {
                    text: 'By team',
                    href: null,
                    icon: {
                        selected: 'personGroup',
                        unselected: 'personGroup',
                    },
                    submenu: [
                        {
                            text: 'Marketing',
                            href: '/resources/marketing',
                        },
                        {
                            text: 'Leaders',
                            href: '/resources/leaders',
                        },
                        {
                            text: 'IT',
                            href: '/resources/it',
                        },
                        {
                            text: 'Sales operations',
                            href: '/resources/sales',
                        },
                    ],
                },
                {
                    text: 'Learn more',
                    href: null,
                    icon: {
                        selected: 'miscLearn',
                        unselected: 'miscLearn',
                    },
                    submenu: [
                        {
                            text: 'Blog',
                            href: '/blog/',
                        },
                        {
                            text: 'Zapier Learn',
                            href: 'https://learn.zapier.com',
                        },
                        {
                            text: 'Events and webinars',
                            href: '/resources/events',
                        },
                        {
                            text: 'Customer stories',
                            href: '/customer-stories',
                        },
                        {
                            text: 'Zapier guides',
                            href: '/resources/guides',
                        },
                    ],
                },
                {
                    text: 'Get help',
                    href: null,
                    icon: {
                        selected: 'navHelp',
                        unselected: 'navHelp',
                    },
                    submenu: [
                        {
                            text: 'Help Center',
                            href: 'https://help.zapier.com/hc/en-us',
                        },
                        {
                            text: 'Community',
                            href: 'https://community.zapier.com/',
                        },
                        {
                            text: 'Hire an Expert',
                            href: '/experts',
                        },
                        {
                            text: 'Support Services',
                            href: '/l/support-services',
                        },
                        {
                            text: 'More about Zapier Support',
                            href: '/l/support',
                        },
                    ],
                },
            ],
            bottomLinks: BOTTOM_LINKS,
            promoArea: [
                {
                    type: 'article-stub',
                    text: 'Zapier quick-start guide',
                    href: '/learn/zapier-quick-start-guide',
                    imageUrl: 'https://cdn.zapier.com/storage/photos/8d754b5e8481fdd190dd7b1cf7738a8d.png',
                    description: 'Create your first Zap with ease',
                    altText: "A simplified user interface design representing a portion of Zapier's platform. There's a vertical menu of platform options. At the top is a dominant orange button with text inside that reads \"Create Zap.\" Beneath the button is a stack of menu icons to represent Zapier's dashboard and zaps.",
                },
                {
                    type: 'link-list',
                    text: 'Developer resources',
                    href: null,
                    links: [
                        {
                            text: 'Developer Platform',
                            href: '/developer-platform',
                        },
                        {
                            text: 'Build an integration',
                            href: '/developer-platform/integrations',
                        },
                        {
                            text: 'Embed an integration',
                            href: '/developer-platform/embed-tools',
                        },
                        {
                            text: 'Integration Partner Program',
                            href: '/developer-platform/partner-program',
                        },
                        {
                            text: 'Documentation',
                            href: 'https://platform.zapier.com',
                        },
                    ],
                },
            ],
        },
        {
            variant: 'link',
            text: 'Enterprise',
            href: '/enterprise',
        },
        {
            variant: 'link',
            text: 'Pricing',
            href: '/pricing',
        },
    ],
    callToAction: {
        href: 'https://zapier.com/l/contact-sales',
        text: 'Contact Sales',
    },
    linksInApp: [
        { text: 'Help', icon: 'navHelp', href: 'https://help.zapier.com/hc/en-us' },
        {
            text: 'Explore apps',
            icon: 'navApps',
            href: '/apps',
        },
    ],
    integrationsCTA: {
        text: 'Explore integrations',
        href: '/apps',
        color: 'primary',
        icon: 'navExplore',
    },
};
//# sourceMappingURL=links.js.map
// @zapier/universal-layout@12.1.15 (040754877)
